import { register } from '@wm/components/base';

export const registerProps = () => {
    register(
        'wm-network-info-toaster',
        new Map(
            []
        )
    );
};
